<template>
    <div class="primary" :class="left?'left-side-button':'right-side-button'">
        <a @click="onClick">
            <div><i class="fas fa-caret-right" :class="{shown:active}"></i></div>
            <p class="primary">{{ title }}</p>
        </a>
    </div>
</template>

<script>
export default {
    name: "CSideButton",
    props: ["title", "value", "left"],

    data: () => ({
        active: false
    }),

    mounted() {
        this.active = this.value === undefined ? true: this.value;
    },

    methods: {
        onClick (event) {
            if (this.value !== undefined) {
                this.active = !this.active;
                this.$emit('input', this.active);
            }

            this.$emit('click', event);
        }
    }
}
</script>

<style scoped>

.left-side-button {
    position: absolute;
    left: -23px;
    font-size: 20pt;
    float: right !important;
    padding-top: 0;
    color: white;
    text-align: center;
    margin-top: 33px;
    padding-bottom: 20px;
}

.left-side-button p {
    writing-mode: vertical-lr;
    transform: rotate(180deg);
    text-orientation: sideways;
    text-align:right;
    padding: 0;
    font-size: 15px;
    color: white;
    margin: 0;
}

.right-side-button I,
.left-side-button i {
    color: white;
}

.right-side-button {
    position: absolute;
    font-size: 20pt;
    float: right !important;
    padding-top: 0;
    color: white;
    text-align: center;
    margin-top: 27px;
    padding-bottom: 20px;
    right: 50px;
}

.right-side-button p {
    writing-mode: vertical-lr;
    text-orientation: sideways;
    text-align:right;
    padding: 0;
    font-size: 15px;
    color: white;
    margin: 0;
}

.shown {
    transform: rotate(180deg);
    -webkit-transition: all 150ms ease-in 0s;
    transition: all 150ms ease-in 0s;
}

</style>